import { render, staticRenderFns } from "./ChatResourceInput.vue?vue&type=template&id=a8dfc930"
import script from "./ChatResourceInput.vue?vue&type=script&lang=js"
export * from "./ChatResourceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports